<script setup>

import { defineProps } from 'vue';

defineProps({
  level: {
    type: String,
    required: true
  }
});

const getBadgeClass = (level) => {
  switch (level) {
    case 'OWNER':
      return 'bg-gradient-primary';
    case 'ADMIN':
      return 'bg-gradient-danger';
    case 'WRITE':
      return 'bg-gradient-warning';
    case 'READ':
      return 'bg-gradient-info';
    case 'PUBLIC':
      return 'bg-gradient-success';
    default:
      return 'bg-gradient-secondary';
  }
};

const getIcon = (level) => {
  switch (level) {
    case 'OWNER':
      return 'fa-crown';
    case 'ADMIN':
      return 'fa-user-shield';
    case 'WRITE':
      return 'fa-edit';
    case 'READ':
      return 'fa-eye';
    case 'PUBLIC':
      return 'fa-globe';
    default:
      return 'fa-question';
  }
};
</script>

<template>
  <span
      class="badge badge-sm"
      :class="getBadgeClass(level)"
      :title="`${level} Access`"
  >
    <i class="fas me-1" :class="getIcon(level)"></i>
    {{ level }}
  </span>
</template>